import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import type { credentials } from 'types/auth'

type UseSentryUserProps = {
	credentials: credentials | null
}
export function useSentryUser(props: UseSentryUserProps) {
	const { credentials } = props
	useEffect(() => {
		if (credentials) {
			return Sentry.setUser({
				id: credentials.userId.value,
				accountId: credentials.accountId.value,
				organizationId: credentials.organizationId.value,
			})
		}
		Sentry.setUser(null)
	}, [credentials])
}

export function setUpSentry() {
	const SENTRY_DNS = import.meta.env.VITE_SENTRY_DSN || null
	const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE
	if (SENTRY_DNS && SENTRY_RELEASE)
		Sentry.init({
			release: SENTRY_RELEASE,
			dsn: SENTRY_DNS,
			integrations: [Sentry.browserTracingIntegration(), Sentry.dedupeIntegration()],
			// Errors are always sent; performance traces are sampled. Request and page-load tracing lives in OpenTelemetry
			// (monitoring/otel.ts, #1662), so Sentry keeps a 10% sample for its own performance views.
			tracesSampleRate: 0.1,
		})
}
